<script>
  import axios from 'axios';
  import { onMount } from 'svelte';
  import { api, pages } from '../../config';
  import { ux } from '../../store';
  import { goto, formatMoney } from '../../util';

  export let params;

  const { credits } = params;
  let aid;
  $: formattedCredits = formatMoney(credits);

  onMount(async () => {
    const { uid, id } = $ux.checkout || {};
    aid = $ux.checkout.aid;
    if (!aid || !uid || !id) return goto(pages.dashboard.url);

    const payload = { id };
    const headers = {
      'x-webforma-aid': aid,
      'x-webforma-uid': uid,
    };

    const closeout = await axios.post(api.checkout.closeout.url, payload, {
      headers,
    });

    if (closeout.status === 200) {
      $ux.checkout = null;
    }
  });
</script>

{#if !$ux.checkout}
  <article data-theme="light">
    <hgroup>
      <h2>Successful Chargeup</h2>
      <h4>
        {formattedCredits} in credit have been added to your account (#{aid})
      </h4>
    </hgroup>
    <div>
      <button class="success" on:click={() => goto(pages.dashboard.url)}
        >Continue</button
      >
    </div>
  </article>
{:else}
  <h4>Loading chargeup status...</h4>
{/if}
